import { Bookmark, Plus } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import Button from 'ui/components/Button';
import { isInIframe } from 'utils/proxyUtils';

export const NoCannedResponse: React.FC<{ showNoFilter: boolean }> = ({
    showNoFilter,
}) => {
    const { t } = useTranslation();
    const navigate = (url: string) => {
        if (isInIframe()) {
            // Send message to parent for navigation
            window.parent.postMessage({
                type: 'NAVIGATE',
                url
            }, '*'); // Will likely replace '*' with production/test origins
        } else {
            const baseUrl =
                import.meta.env.VITE_APP_ATARIM_URL || process.env.CEB_VITE_APP_ATARIM_URL;
            window.open(`${baseUrl}${url}`, '_blank');
        }
    };

    const handleNavigationClick = (link: string) => {
        navigate(link);
    };
    if (showNoFilter) {
        return (
            <div className="flex h-full w-full flex-col items-center justify-center gap-1">
                <Bookmark size={20} aria-hidden="true" className='text-textcolor' />
                <p className="text-sm font-medium text-textcolor">
                    {t('canned_response.empty.not_found', 'No canned responses found')}
                </p>
                <span className="text-center text-sm text-gray-500">
                    {t('canned_response.empty.filter_message', 'We couldn\'t find any canned responses with the filters you have applied.')}
                </span>
                <Button
                    onClick={() => handleNavigationClick(`/settings?tab_flag=canned`)}
                    className="mt-2"
                    size="sm"
                    leftIcon={<Plus size={18} />}>Create a Canned Response</Button>
            </div>
        );
    }

    return (
        <div className="flex h-full w-full flex-col items-center justify-center gap-1">
            <Bookmark size={20} aria-hidden="true" />
            <h2 className="font-medium">
                {t('canned_response.empty.title', 'You\'re all caught up!')}
            </h2>
            <span className="text-center text-sm text-gray-500">
                {t('canned_response.empty.subtitle', 'No canned responses created yet')}
            </span>
            <Button
                size='sm'
                className='w-full'
                onClick={() => handleNavigationClick(`/settings?tab_flag=canned`)}
                aria-label={t('canned_response.buttons.add_aria', 'Add a Canned Response')}
            >
                <Plus size={18} className="mr-1" aria-hidden="true" />
                {t('canned_response.buttons.add', 'Add a Canned Response')}
            </Button>
        </div>
    );
};

export default NoCannedResponse;